'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var flamelink = _interopDefault(require('@flamelink/sdk-app'));
require('@flamelink/sdk-settings-cf');
require('@flamelink/sdk-settings-rtdb');
require('@flamelink/sdk-schemas-cf');
require('@flamelink/sdk-schemas-rtdb');
require('@flamelink/sdk-content-cf');
require('@flamelink/sdk-content-rtdb');
require('@flamelink/sdk-navigation-cf');
require('@flamelink/sdk-navigation-rtdb');
require('@flamelink/sdk-storage-cf');
require('@flamelink/sdk-storage-rtdb');
require('@flamelink/sdk-users-cf');
require('@flamelink/sdk-users-rtdb');

console.warn("\n[Flamelink] Warning!\n\nImporting the whole Flamelink SDK is fine for development or quick prototyping,\nbut it is highly recommended that you only import the individual modules used\nby your application when you use this SDK in production.\n\n---------------------------------- CommonJS ------------------------------------\n\nconst flamelink = require('flamelink/app')\nrequire('flamelink/<module>')\n\n------------------------------- EcmaScript Modules -----------------------------\n\nimport flamelink from 'flamelink/app'\nimport 'flamelink/<module>'\n\n----------------------------------- TypeScript ---------------------------------\n\nimport flamelink from 'flamelink/app'\nimport 'flamelink/<module>'\n\n--------------------------------------------------------------------------------\n\nWhere <module> can be one of 'content', 'navigation', 'storage', 'users' or 'settings'\n");

module.exports = flamelink;
